export { default } from 'app/developer-v3/pages/triggers/TriggerInputsList/Container';
